import { Breadcrumbs } from "components/breadcrumbs"
import { useOne, useParse } from "@refinedev/core"
import { FullScreenLoading } from "components/fullScreenLoading"
import { EditEventAddonForm } from "./components"

interface IEventAddonDetail {
  id: string
  event_id: string
  name?: string
  name_en: string
  name_vi: string
  desc?: string
  desc_en: string
  desc_vi: string
  base_price: number
  stock_total: number | null
  status: string
  type: string
  scope: string
  ticket_ids: string[]
  position: number
  required: boolean
  qty_mode: string
  qty_min: number
  qty_max: number
  has_note: boolean
  note_label_vi: string
  note_label_en: string
  note_placeholder_vi: string
  note_placeholder_en: string
  note_required: boolean
  low_stock_threshold: number
  variants: IAddonVariant[]
  created_by: string
}

interface IAddonVariant {
  id?: string
  label?: string
  label_vi: string
  label_en: string
  price: number
  stock: number
  qty_min: number
  qty_max: number
  position: number
}

export const EditEventAddon: React.FC = () => {
  const parse = useParse()
  const { params } = parse()

  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IEventAddonDetail>({
    resource: "ws-event-addons",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  })

  const addonDetailData = data?.data ?? null

  if (isLoading) {
    return <FullScreenLoading />
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Event Addon" />
      {addonDetailData ? (
        <EditEventAddonForm
          defaultData={addonDetailData}
          id={params?.id}
          eventId={addonDetailData.event_id}
        />
      ) : (
        <></>
      )}
      {isFetching && isPreviousData ? <FullScreenLoading /> : <></>}
    </div>
  )
}
